module.exports = __webpack_public_path__ + "static/media/allRightMen.de8fb305.jpg";